import * as React from 'react';
import moment from 'moment';

import { MiniCalendarGridItemViewProps, MiniCalendarGridItemView } from './grid-item.view';

export interface MiniCalendarGridViewProps {
    gridDates: MiniCalendarGridItemViewProps[];
}

const weekdays = moment.weekdays(true).map((weekday, index) => (
    <li key={index} className="mini-cal-weekday">{weekday.substr(0, 2)}</li>
));

/**
 * Renders all of the weekdays and grid items.
 */
export const MiniCalendarGridView: React.FunctionComponent<MiniCalendarGridViewProps> = (props) => {
    return (
        <>
            <ul className="mini-cal-weekdays">
                {weekdays}
            </ul>
            <ul className="mini-cal-days">
                {props.gridDates.map((props, index) => (
                    <MiniCalendarGridItemView key={index} {...props} />
                ))}
            </ul>
        </>
    )
}